import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import {useSelector, useDispatch} from 'react-redux'
import {ProductCard} from './ProductCard'
import {CategoryCard} from './CategoryCard'

import {useLocation} from 'react-router-dom'
import {getFormatedData} from '../../../functions/getFormatedData'
import {colors} from '../../../styles/colors'
import {Pagination} from './product_page/Pagination'

const Container = styled.article`
    width: 100%;
    
    .categories-cards,
    .products-cards {
        display: grid;

        @media (max-width: 767.98px) {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    .categories-cards {
        grid-template-columns: repeat(auto-fill, minmax(420px, 420px));
        grid-gap: 20rem;

    }
    .products-cards {
        grid-template-columns: repeat(auto-fill, minmax(320px, 320px));
    }
`;

const AddNewProductButton = styled.div`
    margin-bottom: 5rem;
    margin-left: 5rem;
    cursor: pointer;

    font-family: 'SF UI Text', sans-serif;
    font-weight: 300;
    font-size: 2.5rem;
    line-height: 133%;

    color: ${colors.dark_blue};

    :hover {
        color: ${colors.red};
    }
`

export const OutputtedCardList = () => {

    const dispatch = useDispatch()
    const loggedIn = useSelector(state => state.firebase.auth.isEmpty === false)
    const location = useLocation().pathname

    const categories = getFormatedData(useSelector(state => state.firebase.data.products && state.firebase.data.products.categories))
    const products = getFormatedData(useSelector(state => state.firebase.data.products && state.firebase.data.products.products_list))

    const [selectedCategory, setSelectedCategory] = useState([])

    const [currentPage, setCurrentPage] = useState(1)
    const productsPerPage = 15

    const indexOfLastProduct = currentPage * productsPerPage
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage

    function areSubcategoriesIncluded(categories, selectedCategory) {
        if (categories) {
            return (categories.filter(category => category.parent_category_name === selectedCategory).length === 0)
        }
    }

    function shouldAddButtonRender() {
        if (categories) {
            return loggedIn && areSubcategoriesIncluded(categories, selectedCategory)
        }
    }

    function shouldPaginatorRender() {
        if (products) {
            return (products.filter(product => product.category === selectedCategory).length > 15)
        }
    }

    useEffect(() => {
        const path_arr = location.split('/')
        setSelectedCategory(path_arr[path_arr.length - 1])
    }, [location])

    return (
        <Container>
            {
                shouldAddButtonRender()
                    ? <AddNewProductButton className="add-new" onClick={() => dispatch({
                        type: 'ADD_NEW_PRODUCT_OPENED',
                        value: selectedCategory
                    })}> Добавить продукт </AddNewProductButton>
                    : null
            }
            {categories
                ?
                <div className='categories-cards'>
                    {categories.map(category => (
                        category.parent_category_name === selectedCategory
                            ? <CategoryCard category_data={category} key={category.key}/>
                            : null
                    ))}
                </div>
                : null
            }
            {
                products
                    ? <>
                        <div className='products-cards'>
                            {get_sorted_products(products, selectedCategory).slice(indexOfFirstProduct, indexOfLastProduct).map(product =>
                                <ProductCard product_data={product} key={product.key}/>)}
                        </div>
                        {
                            shouldPaginatorRender()
                                ? <Pagination
                                    productsPerPage={productsPerPage}
                                    totalProducts={get_sorted_products(products, selectedCategory).length}
                                    paginate={(pageNumber) => setCurrentPage(pageNumber)}
                                    currentPage={currentPage}
                                />
                                : null
                        }
                    </>
                    : null
            }


        </Container>
    )

}

function get_sorted_products(products, selectedCategory) {
    const sorted_products = []
    products.forEach(product => product.category === selectedCategory ? sorted_products.push(product) : null)

    return sorted_products
}
